/**
 * Created by Mark on 23/11/2016.
 */

import ApplicationServices from './base-service.js';
import AuthenticationConstants from '../constants/authnetication.js';
import LoginActions from '../actions/authentication.actions.js';


class Authentication {

    constructor(){
        this.isAuthenticated = false;
        this.timeout = null;
    }

    getUnixPermissions(){
        return ApplicationServices.call(AuthenticationConstants.PERMISSIONS , {}).then(function(response){
            LoginActions.grantPermissions(response.permission);
        });
    }

    getUserData(){
        return ApplicationServices.call(AuthenticationConstants.USER , {}).then(function(response){
           console.log(response);
            LoginActions.getUserData(response);
            return response
        }.bind(this));
    }

    authenticate(username , password){
        return ApplicationServices.call(AuthenticationConstants.LOGIN_URL , {username:username , pass:password }).then(function(response){
            this.getUnixPermissions().then(function(){
                LoginActions.authenticateUser(response.newToken);
            });
        }.bind(this));
    }

    refreshAuthenticationToken(token){
        return ApplicationServices.call(AuthenticationConstants.REFRESH_URL , {token:token}).then(function(response){
            LoginActions.authenticateUser(response.newToken);
        });
    }

}


export default new Authentication();


// WEBPACK FOOTER //
// ./src/services/authenticate-services.js